var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a ng-model=\"showModal\" ng-click=\"$termsCtrl.showTerms()\" class=\"terms-link\">Click here to view the terms and conditions</a>";
var id1="javascripts/terms/terms.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/terms/terms.template.html
// module id = 1324
// module chunks = 0